import { type ReactElement } from 'react';
import { ApiKeysSection } from './ApiKeysSection';
import { PolicySettingsSection } from './PolicySettingsSection';

type Props = {
  isEnforcePolicyModeEnabled: boolean;
  isSecretConfidenceThresholdEnabled: boolean;
};

export function PersonalWorkspaceSubTab({
  isEnforcePolicyModeEnabled,
  isSecretConfidenceThresholdEnabled,
}: Props): ReactElement {
  return (
    <div className="space-y-7">
      <ApiKeysSection />
      {(isEnforcePolicyModeEnabled || isSecretConfidenceThresholdEnabled) && (
        <PolicySettingsSection
          isEnforcePolicyModeEnabled={isEnforcePolicyModeEnabled}
          isSecretConfidenceThresholdEnabled={
            isSecretConfidenceThresholdEnabled
          }
        />
      )}
    </div>
  );
}
